import { Close } from '@mui/icons-material';
import { TextField, IconButton } from '@mui/material';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { z } from 'zod';

export const PostTitleSchema = z.object({
  title: z.string(),
});

export const PostTitlePinnedSchema = z.object({
  title: z.string().min(1, 'A title is required when a post is pinned'),
});

export type PostTitleFormData = z.infer<typeof PostTitleSchema>;

interface Props {
  control: Control<PostTitleFormData>;
}

export const PostTitleForm = ({ control }: Props) => {
  return (
    <Controller
      name="title"
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          autoFocus
          fullWidth
          label="Title"
          error={Boolean(fieldState.error)}
          helperText={fieldState.error?.message}
          {...field}
          slotProps={{
            input: {
              ...field,
              endAdornment: field.value && (
                <IconButton
                  size="small"
                  sx={(theme) => ({
                    color: theme.palette.grey[500],
                  })}
                  onClick={() => field.onChange('')}
                >
                  <Close />
                </IconButton>
              ),
            },
          }}
        />
      )}
    />
  );
};
